<template>
  <div>
    <el-row :gutter="10" style="margin: 10px 0px">
      <el-col :xs="24" :lg="8" style="padding: 6px 0">
        <span> 时间类型： </span>
        <el-radio-group v-model="dataTpye" @change="getShowData">
          <el-radio label="currMonth">当月</el-radio>
          <el-radio label="all">本年累计</el-radio>
        </el-radio-group>
      </el-col>
      <el-col
        :xs="24"
        :lg="8"
        v-if="dataRange === 'month'"
        style="padding: 6px 0"
      >
        <span style="margin-left: 20px"> 时间： </span>
        <el-date-picker
          class="jiance_phone_date"
          :editable="false"
          :clearable="false"
          v-model="times"
          type="monthrange"
          size="mini"
          value-format="yyyy-MM"
          @change="monthChange"
          :picker-options="pickerOptions"
          placeholder="选择月"
        >
        </el-date-picker>
      </el-col>
    </el-row>
    <el-row :gutter="10" style="margin: 10px 15px">
      <el-col align="center" style="font-size: 16px">
        全县{{
          dataIndexOptions.find((ele) => ele.value === dataIndex).label
        }}情况
      </el-col>
    </el-row>
    <el-row style="margin: 10px 0px">
      <el-col :span="24">
        <product v-if="showArea" :area-data="areaData" />
      </el-col>
    </el-row>
    <el-link style="margin: 10px 15px" type="primary" @click="exportData">{{
      exportLabel
    }}</el-link>
    <el-row style="margin: 10px 0px">
      <el-col :span="24">
        <el-table
          v-loading="loading"
          border
          size="mini"
          :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
          stripe
          :data="tableData"
        >
          <el-table-column type="index" label="序号" width="50" fixed>
          </el-table-column>
          <el-table-column prop="date_range_show" label="填报时间" fixed>
          </el-table-column>
          <el-table-column :label="title">
            <el-table-column
              prop="mm_this"
              :formatter="handelFix2"
              sortable
              label="本月"
            >
            </el-table-column>
            <el-table-column
              prop="this_speed"
              :formatter="handelFix1"
              sortable
              label="同比增速（%）"
            >
            </el-table-column>
            <el-table-column
              prop="mm_range"
              :formatter="handelFix2"
              sortable
              label="累计"
            >
            </el-table-column>
            <el-table-column
              :formatter="handelFix1"
              sortable
              prop="range_speed"
              label="同比增速（%）"
            >
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Product from "@/components/Echarts/product.vue";
import { export2Excel } from "@/utils/utils";
export default {
  props: {
    dataTpyeDef: {
      type: String,
      default: "",
    },
    regionCodeDef: {
      type: String,
      default: "",
    },
    dataIndexDef: {
      type: String,
      default: "",
    },
    dataRangeDef: {
      type: String,
      default: "",
    },
    timesDef: {
      type: String,
      default: "",
    },
    unit: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      showArea: false,
      exportLabel: "<<点击此处可导出报表",
      areaName: "",
      startTime: "",
      endTime: "",
      srcDataList: "",
      dialogTableVisible: false,
      queryData: {
        name: this.regionCodeDef,
      },
      dataIndexOptions: [
        {
          value: "gyzjz",
          label: "工业增加值",
        },
        {
          value: "yysr",
          label: "营业收入",
        },
        {
          value: "lrze",
          label: "利润总额",
        },
      ],
      dataRangeOptions: [
        {
          value: "month",
          label: "月度",
        },
      ],
      dataTpye: this.dataTpyeDef, //时间类型
      dataIndex: this.dataIndexDef, //数据指标
      dataRange: this.dataRangeDef, //数据类型
      times: this.timesDef, //时间
      defaultQuarterValue: "", //时间
      defaultMonthValue: "", //时间
      tableData: [],
      areaData: {
        xAxis: [],
        curr: {
          name: "",
          data: [],
        },
        profit: {
          name: "",
          data: [],
        },
        unit: this.unit,
      },
    };
  },
  components: {
    Product,
  },
  watch: {
    dataRange: function (value, oldValue) {
      if (value === "quarter") {
        this.times = this.defaultQuarterValue;
      } else if (value === "month") {
        this.times = this.defaultMonthValue;
      } else {
        this.times = new Date().getFullYear() + "-12";
      }
      this.initData();
    },
  },
  methods: {
    handelFix1(row, column) {
      if (row[column.property] && !isNaN(row[column.property])) {
        return row[column.property].toFixed(1);
      } else {
        return row[column.property];
      }
    },
    handelFix2(row, column) {
      if (row[column.property] && !isNaN(row[column.property])) {
        return row[column.property].toFixed(2);
      } else {
        return row[column.property];
      }
    },
    dataRangeChange(value) {
      if (value === "month") {
        this.dataTpye = "currMonth";
      } else if (value === "quarter") {
        this.dataTpye = "currQuarter";
      } else {
        this.dataTpye = "all";
      }
    },
    initData() {
      const self = this;
      this.loading = true;
      this.queryData.startTime = this.startTime;
      this.queryData.endTime = this.endTime;
      this.$axios
        .post("/business/product/queryList", this.queryData)
        .then((res) => {
          this.tableData = [];
          this.areaData = {
            xAxis: [],
            curr: {
              name: "",
              data: [],
            },
            profit: {
              name: "",
              data: [],
            },
            unit: this.unit,
          };
          this.tableData = res.data;
          this.getShowData();
          this.loading = false;
        });
    },
    getShowData() {
      const self = this;
      this.showArea = false;
      this.areaData = {
        xAxis: [],
        curr: {
          name: "",
          data: [],
        },
        profit: {
          name: "",
          data: [],
        },
        unit: this.unit,
      };
      this.tableData.forEach((item) => {
        item.date_range_show =
          item.date_range.split("-")[0] +
          "年" +
          item.date_range.split("-")[1] +
          "月";
        this.areaData.xAxis.push(item.date_range_show);
        if (this.dataTpye === "all") {
          this.areaData.curr.name = "累计";
          this.areaData.profit.name = "同比增速";
          this.areaData.curr.data.push(item.mm_range);
          this.areaData.profit.data.push(item.range_speed);
        } else {
          this.areaData.curr.name = "当月";
          this.areaData.profit.name = "同比增速";
          this.areaData.curr.data.push(item.mm_this);
          this.areaData.profit.data.push(item.this_speed);
        }
      });
      console.log("this.areaData:", this.areaData);
      setTimeout(function () {
        self.showArea = true;
      }, 5);
    },
    monthChange(value) {
      this.startTime = value[0];
      this.endTime = value[1];
      this.initData();
    },
    exportData() {
      const column = [
        {
          title: "产品名称",
          key: "name",
          rowspan: 2,
        },
        {
          title: this.title,
          data: [
            {
              title: "本月",
              toFixed: 2,
              key: "mm_this",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "this_speed",
            },
            {
              title: "1-本月",
              toFixed: 2,
              key: "mm_range",
            },
            {
              title: "同比增速(%)",
              toFixed: 1,
              key: "range_speed",
            },
          ],
          colspan: 4,
        },
      ];
      let timeStr =
        this.times[0].slice(0, 4) +
        "年" +
        this.times[0].slice(5, 7) +
        "月到" +
        this.times[1].slice(0, 4) +
        "年" +
        this.times[1].slice(5, 7) +
        "月";
      export2Excel(column, this.tableData, this.title + "_" + timeStr);
    },
  },
  created() {
    console.log(this.timesDef);
    this.times = this.defaultMonthValue;
    this.startTime = this.timesDef.slice(0, 4) + "-01";
    this.endTime = this.timesDef;
    this.times = [this.startTime, this.endTime];
    this.initData();
  },
};
</script>